<template>
    <ComparisonCard
        v-if="dataValues[0] + dataValues[1] > 0"
        :values="dataValues"
        :labels="labels"
        :quotes="quotes"
        :comparisonLabels="['People liked', 'People disliked']"
    >
        <template v-slot:header-title-text>
            <h3 class="soft-text">{{ fullName }}</h3>
        </template>
        <template v-slot:header-title-text-expanded>
            <p class="soft-text">{{ fullName }}</p>
            <h4 class="left-text">
                <strong>{{ gradeLabel }}</strong>
            </h4>
        </template>

        <template v-slot:header-title-text-mobile>
            <h4 class="soft-text">{{ name }}</h4>
            <p class="primary-text subheader">{{ firstName }} is voted {{ gradeLabel.toLowerCase() }}</p>
        </template>
        <template v-slot:header-title-text-expanded-mobile>
            <h4 class="soft-text">
                {{ fullName }} is <strong class="primary-text">{{ gradeLabel }}</strong>
            </h4>
        </template>
    </ComparisonCard>
</template>

<script>
import ComparisonCard from "@/components/cards/MetricComparisonCard";

export default {
    name: "ProfessorCard",
    props: {
        name: String,
        reviews: Array,
    },
    components: {
        ComparisonCard,
    },
    computed: {
        fullName() {
            return this.name == "all" ? "All Professors" : this.name;
        },
        firstName() {
            return this.name == "all" ? "All Professors" : this.name.split(" ")[0];
        },
        gradeLabel() {
            let diff = this.dataValues[0] - this.dataValues[1];
            return diff < 0 ? "Widely disliked" : "Widely liked";
        },
        dataValues() {
            let good = 0,
                bad = 0;
            this.reviews.forEach((r) => {
                let d = r.rating.professor;
                if (d > 3) good += 1;
                if (d < 3) bad += 1;
            });
            return [good, bad];
        },
        quotes() {
            let goodReviews = [],
                badReviews = [];
            this.reviews.forEach((r) => {
                let d = r.rating.professor;
                if (
                    r.professorMetrics !== undefined &&
                    r.professorMetrics.comment !== undefined &&
                    r.professorMetrics.comment !== null
                ) {
                    let ptext = r.professorMetrics.comment;
                    if (d > 3) {
                        goodReviews.push(ptext);
                    } else if (d < 3) {
                        badReviews.push(ptext);
                    }
                }
            });
            return goodReviews.length > 0 || badReviews.length > 0 ? [goodReviews, badReviews] : null;
        },
    },
    created() {
        this.$on("expand", () => {
            this.$parent.$emit("expand");
        });
    },
    data() {
        return {
            labels: ["Good", "Bad"],
        };
    },
};
</script>
